var FiasAPIResultFactory =
/** @class */
function () {
  function FiasAPIResultFactory() {}

  FiasAPIResultFactory.success = function (data) {
    return {
      success: true,
      data: data
    };
  };

  FiasAPIResultFactory.fail = function (message) {
    if (message === void 0) {
      message = '';
    }

    return {
      success: false,
      error: new Error(message)
    };
  };

  return FiasAPIResultFactory;
}();

export { FiasAPIResultFactory };